import { render, staticRenderFns } from "./intersetGroupDetail.vue?vue&type=template&id=1c6e79e2&scoped=true"
import script from "./intersetGroupDetail.vue?vue&type=script&lang=js"
export * from "./intersetGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./intersetGroupDetail.vue?vue&type=style&index=0&id=1c6e79e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6e79e2",
  null
  
)

export default component.exports